import React, { useState, useEffect } from 'react';
import { TrendingUp, RefreshCw } from 'lucide-react';

import { getApiBaseUrl } from '../utils/urlHelper';

const API_URL = getApiBaseUrl();

const ExchangeRateBar = ({ variant = 'public' }) => {
  const [rates, setRates] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchRates = async () => {
    try {
      const res = await fetch(`${API_URL}/api/exchange-rates`);
      const data = await res.json();
      if (data.usd_brl) {
        setRates(data);
      }
    } catch (e) {
      // silent fail
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRates();
    // Only update when admin manually changes rates
    const handleUpdate = () => fetchRates();
    window.addEventListener('exchangeRatesUpdated', handleUpdate);
    return () => {
      window.removeEventListener('exchangeRatesUpdated', handleUpdate);
    };
  }, []);

  if (loading || !rates) return null;

  const formatBRL = (val) => val.toFixed(2).replace('.', ',');

  if (variant === 'admin') {
    return (
      <div className="flex items-center gap-3 text-sm" data-testid="exchange-rate-admin">
        <TrendingUp className="w-4 h-4 text-yellow-400" />
        <span className="text-gray-200">
          <span className="font-medium text-white">Dolar:</span> R$ {formatBRL(rates.usd_brl)}
        </span>
        <span className="text-gray-400">|</span>
        <span className="text-gray-200">
          <span className="font-medium text-white">Euro:</span> R$ {formatBRL(rates.eur_brl)}
        </span>
      </div>
    );
  }

  // Public site variant
  return (
    <div className="flex items-center gap-2 text-xs sm:text-sm" data-testid="exchange-rate-public">
      <TrendingUp className="w-3.5 h-3.5" />
      <span>
        <span className="font-medium">Dolar:</span> R$ {formatBRL(rates.usd_brl)}
      </span>
      <span className="opacity-50">|</span>
      <span>
        <span className="font-medium">Euro:</span> R$ {formatBRL(rates.eur_brl)}
      </span>
    </div>
  );
};

export default ExchangeRateBar;
